import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class HistoricalValuesService {

  private selectedProductTypeSource = new Subject<any>();
  public selectedProductTypeSource$ = this.selectedProductTypeSource.asObservable();

  private filterSource = new Subject<any>();
  public filterSource$ = this.filterSource.asObservable();

  constructor() {
  }

  public triggerFilterChangeEvent(filterInformation: any) {
    this.filterSource.next(filterInformation);
  }

  public triggerSearchEvent(productType: any, startDate: Date, endDate: Date) {
    this.selectedProductTypeSource.next({productType: productType, startDate: startDate, endDate: endDate});
  }

}
